import { render, staticRenderFns } from "./MovementsChart.vue?vue&type=template&id=76bed02c"
import script from "./MovementsChart.vue?vue&type=script&lang=js"
export * from "./MovementsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports